import React from 'react';
import Table from '@components/viewer-module/SubscribersTable';
import AdvancedSessionDetails from '@components/viewer-module/AdvancedSession';
import { useViewerStore } from '@store/viewerModule/base';
import { ContentWrapper, TableWrapper } from '../styled';
import SearchHelpText from './SearchHelpText';

function Content() {
  const [{ viewerId }] = useViewerStore();

  return (
    <ContentWrapper>
      <TableWrapper>
        {viewerId ? <Table /> : <SearchHelpText />}
      </TableWrapper>
      <AdvancedSessionDetails />
    </ContentWrapper>
  );
}

export default Content;
